module.exports = __webpack_public_path__ + "img/Jesse Boehm.af45f970.jpg";